/**
* @Author: zachalam
* @Date:   2017-01-19T16:56:51-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-19T16:57:37-08:00
*/

import React, { Component } from 'react';
import Favorites from '../components/pages/Favorites/Favorites';
import { connect } from 'react-redux';
import { favToggle, storeFavChange, clearFavs, refreshFavs } from '../actions/favActions';
import { refreshAccount } from '../actions/profileActions';

class FavoritesContainer extends Component {

  state = {
    lastPage: this.props.route.page
  }

  componentWillMount() {
    // refresh data on new page
    this.props.refresh(this.props.route.page);
  }


  componentWillUpdate(nextProps) {
    // refresh data if page changed.
    let next = nextProps.route.page;
    if((next) && next != this.props.route.page) {
      this.props.refresh(next);
    }
  }

  render() {
    return (
      <Favorites {...this.props} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    fav: state.fav,
    moreExists: Boolean(state.meta.fav_current_page < state.meta.fav_total_pages)
  }
};

const mapDispatchToProps = (dispatch,ownProps) => {
  return {
    refresh(route) {
      // refresh data according to route.
      dispatch(refreshFavs(route,true));
      // also refresh account (for header counts).
      dispatch(refreshAccount());
    },
    toggle: (username,favKey) => {
      // notify store
      dispatch(storeFavChange(favKey));
      // notify api
      dispatch(favToggle(username));
    },
    loadMore(route) {
      dispatch(refreshFavs(route,false));
    }
  };
}

export default connect(mapStateToProps,mapDispatchToProps)(FavoritesContainer);



// WEBPACK FOOTER //
// ./src/containers/FavoritesContainer.jsx